export default "__VITE_ASSET__735e0c45__"